import { useContext, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Alert
} from '@mui/material';

import { AuthContext, delete_items } from 'components';

const ITEM_DELETION_LIMIT = 500

export const DeleteModal = (props) => {
  const { items, selected, onClose, onDelete, renderButton } = props;
  const [ open, setOpen ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const { seasons, selectedSeason, selectedStore, selectedCollection, notify } = useContext(AuthContext)

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    if (onClose) {
      onClose()
    }
    setOpen(false);
  }

  const handleAction = () => {
    if (!selected) {
      return
    }

    let bulk_delete = []

    delete_items({
      store: selectedStore,
      season: selectedSeason,
      collection: selectedCollection,
      items: items.map(e => e.id).slice(0, ITEM_DELETION_LIMIT)
    }).then((res) => {
      notify({
        message: `${items.length} item${items.length > 1 ? 's have' : ' has'} been deleted from ${seasons[selectedSeason]?.displayName}`
      })
      if (onDelete) {
        onDelete()
      }
      handleClose()
      setLoading(false)
    })
  };
 
  return (
    <>
      {renderButton ? (
        <Button onClick={handleOpen} {...renderButton.props}/>
      ) : (
        <MenuItem onClick={handleOpen} component="div" disabled={!selected} color="error" aria-label="add">
          <div style={{color: 'red'}}>Delete</div>
        </MenuItem>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          Delete Product{items.length > 1 ? 's' : null}?
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ textAlign: 'center' }}>
            {items.length > ITEM_DELETION_LIMIT ? (
              <span>You selected {items.length} products, but only {ITEM_DELETION_LIMIT} can be deleted at a time. <br/> The first {ITEM_DELETION_LIMIT} will be deleted.</span>
            ) : (
              <>
                {items.length > 1 ? (
                  <span>Are you sure you want to delete {items.length} products?</span>
                ) : (
                  <span>Are you sure you want to delete the selected product?</span>
                )}
              </>
            )}

            <div><br/>You will be able to restore {items.length > 1 ? 'them' : 'it'} later.</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {loading ? (
            <Button onClick={handleClose}>Dismiss</Button>
          ) : (
            <>
              <Button onClick={handleClose}>Cancel</Button>
              <Button color="error" disabled={loading} onClick={() => { setLoading(true); setTimeout(handleAction, 200) }} autoFocus>{items.length > ITEM_DELETION_LIMIT ? `Delete ${ITEM_DELETION_LIMIT}` : `Delete`}</Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  )
}